var render = function render() {
  var _vm = this,
      _c = _vm._self._c;

  return _c('el-dialog', {
    staticClass: "select-person",
    attrs: {
      "visible": _vm.openDialog,
      "close-on-click-modal": _vm.options.dialogCloseOnClickModal,
      "title": _vm.options.dialogTitle,
      "width": _vm.options.dialogWidth,
      "append-to-body": ""
    },
    on: {
      "close": _vm.closeDialog
    }
  }, [_c('el-input', {
    staticClass: "el-sp-searchbar",
    staticStyle: {
      "width": "380px"
    },
    attrs: {
      "placeholder": "请输入姓名/职工号",
      "clearable": "",
      "size": "small"
    },
    on: {
      "clear": _vm.searchUser
    },
    nativeOn: {
      "keyup": function ($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) return null;
        return _vm.searchUser.apply(null, arguments);
      }
    },
    model: {
      value: _vm.queryValue,
      callback: function ($$v) {
        _vm.queryValue = typeof $$v === 'string' ? $$v.trim() : $$v;
      },
      expression: "queryValue"
    }
  }, [_c('template', {
    slot: "append"
  }, [_c('el-button', {
    staticClass: "input_search",
    attrs: {
      "type": "primary",
      "size": "small"
    },
    on: {
      "click": _vm.searchUser
    }
  }, [_vm._v("搜索")])], 1)], 2), _c('div', {
    staticClass: "el-select-person"
  }, [_vm.options.showDepartment ? _c('el-sp-left', {
    ref: "el-sp-left",
    attrs: {
      "tree-data": _vm.treeData,
      "deptIds": _vm.options.deptIds,
      "currentTreeNode": _vm.currentTreeNode,
      "tab-data": _vm.tabData
    },
    on: {
      "on-select": _vm.treeItemSelect_p,
      "change-tab": _vm.clickTab_p
    }
  }) : _vm._e(), _c('el-sp-center', {
    ref: "el-sp-center",
    attrs: {
      "users": _vm.options.showDepartment ? _vm.users : _vm.copy_users,
      "type": _vm.options.type,
      "selected": _vm.selected,
      "is-show-loadmore": _vm.isShowLoadmore,
      "thead-data": _vm.theadData,
      "position-list": _vm.positionList,
      "show-position": _vm.options.showPosition
    },
    on: {
      "on-check": _vm.check_p,
      "on-search-user": _vm.searchUser,
      "change-position": _vm.changePosition
    }
  }), _c('el-sp-right', {
    attrs: {
      "thead-data": _vm.theadData
    },
    on: {
      "on-delete": _vm.handleDelete,
      "on-check-item": _vm.checkItem,
      "on-move-down": _vm.moveDown,
      "on-move-up": _vm.moveUp,
      "on-clear": _vm.handleDeleteAll,
      "on-set-bottom": _vm.setBottom,
      "on-set-top": _vm.setTop,
      "on-selectall": _vm.selectAllOrClear
    },
    model: {
      value: _vm.selected,
      callback: function ($$v) {
        _vm.selected = $$v;
      },
      expression: "selected"
    }
  })], 1), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "size": "small"
    },
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v("取消")]), _c('el-button', {
    attrs: {
      "type": "primary",
      "size": "small"
    },
    on: {
      "click": _vm.confirm
    }
  }, [_vm._v("确定")]), _vm.options.enableAddToGroup ? _c('el-button', {
    attrs: {
      "disabled": _vm.currentTabId !== '2',
      "type": "primary",
      "size": "small"
    },
    on: {
      "click": _vm.openAddToGroupDialog
    }
  }, [_vm._v(" " + _vm._s('添加到' + _vm.groupTabName) + " ")]) : _vm._e()], 1), _c('el-dialog', {
    attrs: {
      "append-to-body": "",
      "visible": _vm.groupProps.openGroupDialog,
      "width": "35%",
      "close-on-click-modal": false,
      "title": '请选择' + _vm.groupTabName
    }
  }, [_c('el-form', {
    ref: "groupProps",
    attrs: {
      "size": "small",
      "model": _vm.groupProps,
      "rules": _vm.validaRules,
      "label-width": "80px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "已有分组",
      "prop": "selectValue"
    }
  }, [_c('el-select', {
    staticClass: "el-sp-group-select",
    staticStyle: {
      "width": "80%"
    },
    attrs: {
      "clearable": "",
      "placeholder": "请选择"
    },
    on: {
      "change": _vm.changeSelect
    },
    model: {
      value: _vm.groupProps.selectValue,
      callback: function ($$v) {
        _vm.$set(_vm.groupProps, "selectValue", $$v);
      },
      expression: "groupProps.selectValue"
    }
  }, _vm._l(_vm.groupProps.groups, function (item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": item.label,
        "value": item.id
      }
    });
  }), 1)], 1), _c('el-form-item', {
    attrs: {
      "label": "新建分组",
      "prop": "inputValue"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "80%"
    },
    attrs: {
      "placeholder": "请输入"
    },
    on: {
      "change": _vm.changeInput
    },
    model: {
      value: _vm.groupProps.inputValue,
      callback: function ($$v) {
        _vm.$set(_vm.groupProps, "inputValue", typeof $$v === 'string' ? $$v.trim() : $$v);
      },
      expression: "groupProps.inputValue"
    }
  })], 1)], 1), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "size": "small"
    },
    on: {
      "click": function ($event) {
        _vm.groupProps.openGroupDialog = false;
      }
    }
  }, [_vm._v("取消")]), _c('el-button', {
    attrs: {
      "type": "primary",
      "size": "small"
    },
    on: {
      "click": _vm.addToGroup
    }
  }, [_vm._v("确定")])], 1)], 1)], 1);
};

var staticRenderFns = [];
export { render, staticRenderFns };